import { Container, Row, Col, Card } from 'react-bootstrap';

const Privacy = () => {
  const sections = [
    {
      title: '1. Information We Collect',
      content: 'We collect information you provide directly: name, email, date of birth, photos, profile information, and preferences. We also collect usage data: device information, IP address, browser type, pages visited, and interaction data. Location data may be collected with your consent.'
    },
    {
      title: '2. How We Use Your Information',
      content: 'We use your information to: provide and improve our services; match you with compatible users; personalize your experience; communicate with you; ensure safety and security; comply with legal obligations; and analyze usage patterns to enhance our platform.'
    },
    {
      title: '3. Information Sharing',
      content: 'We share your profile information with other users as part of the service. We may share data with: service providers who assist our operations; law enforcement when required; in connection with a merger or acquisition. We never sell your personal information to third parties.'
    },
    {
      title: '4. Data Security',
      content: 'We implement industry-standard security measures including encryption, secure servers, and access controls. However, no method of transmission over the internet is 100% secure. We cannot guarantee absolute security but continuously work to protect your data.'
    },
    {
      title: '5. Your Rights',
      content: 'You have the right to: access your personal data; correct inaccurate information; delete your account and data; export your data; opt out of marketing communications; and withdraw consent for optional data processing. Contact us to exercise these rights.'
    },
    {
      title: '6. Cookies and Tracking',
      content: 'We use cookies and similar technologies to remember your preferences, analyze usage, and deliver personalized content. You can manage cookie preferences through your browser settings. See our Cookie Policy for more details.'
    },
    {
      title: '7. Data Retention',
      content: 'We retain your data while your account is active and for a reasonable period afterward for legal and business purposes. Deleted accounts are purged within 90 days, except where retention is required by law or for legitimate business interests.'
    },
    {
      title: '8. International Transfers',
      content: 'Your data may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place for international transfers, including standard contractual clauses and compliance with applicable data protection laws.'
    },
    {
      title: '9. Children\'s Privacy',
      content: 'Paperdate is not intended for users under 18 years of age. We do not knowingly collect personal information from children. If we learn we have collected data from a child, we will delete it promptly. Please contact us if you believe a child has provided us with personal information.'
    },
    {
      title: '10. Changes to This Policy',
      content: 'We may update this Privacy Policy from time to time. We will notify you of significant changes via email or through the app. Your continued use after changes constitutes acceptance of the updated policy.'
    },
    {
      title: '11. Contact Us',
      content: 'For privacy-related questions or to exercise your rights, contact our Data Protection Officer at privacy@paperdate.io or write to: Paperdate Privacy, 123 Dating Street, San Francisco, CA 94102.'
    }
  ];

  return (
    <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col lg={8} className="text-center">
          <h1 className="display-4 fw-bold mb-4">Privacy Policy</h1>
          <p className="text-muted">Last updated: January 1, 2024</p>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col lg={10}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4 p-lg-5">
              <p className="text-muted mb-4">
                At Paperdate, we take your privacy seriously. This Privacy Policy explains how we collect, 
                use, disclose, and safeguard your information when you use our dating platform.
              </p>
              {sections.map((section, index) => (
                <div key={index} className={index < sections.length - 1 ? 'mb-4' : ''}>
                  <h5 className="fw-bold mb-3">{section.title}</h5>
                  <p className="text-muted mb-0">{section.content}</p>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Privacy;

